"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uuid = require("uuid");
class UuidHelper {
    static new() {
        return uuid.v4();
    }
}
exports.UuidHelper = UuidHelper;
//# sourceMappingURL=Uuid.js.map